<template>
  <w-dialog :dialog-state="dialogState" @handleClose="handleClose" :token='token' >
    <div slot="content" class="combine-cv-container" >
      <div class="main_header" >
        <div class="header_title">
          合并中英文
        </div>
        <div class="close" @click="handleClose"><i class="iconfont iconx"></i></div>
      </div>
      <div class="main_body" >
        <div class="resume-select" v-if="defaultCvFirst">
          <div class="resume-select-title">
            {{this.cv_lang === "cn" ? "中文简历" : "英文简历"}}
          </div>
          <div class="resume-select-value">
            <img class="icon" src="https://files.wondercv.com/service_cv.png">
            <div class="text">
              {{cv_name}}
            </div>
          </div>
          <div class="resume-select-switch" @click="switchOrder()" v-if="defaultCvFirst">
            <el-tooltip class="item" effect="dark" content="调整顺序" placement="top">
              <i class="iconfont icontiaozhengshunxu" />
            </el-tooltip>
          </div>
        </div>
        <div class="resume-select">
          <div class="resume-select-title">
            {{this.cv_lang === "cn" ? "英文简历" : "中文简历"}}
          </div>
          <div class="resume-select-select" v-if="otherCvs.length > 0">
            <el-select v-model="otherCvToken" placeholder="请选择您的简历" style="width: 100%">
              <el-option class="combine-select-option" v-for="item in otherCvs"
                :key="item.token"
                :value="item.token"
                :label="item.cv_name">
                {{item.cv_name}}
              </el-option>
            </el-select>
          </div>
          <div class="resume-select-select" v-else>
            <el-select v-model="otherCvToken" placeholder="请选择您的简历" style="width: 100%">
              <el-option class="combine-select-option"
                key="noresume"
                value="noresume"
                label="当前暂无简历">
                <div class="no-resume" @click="goToMoban">
                  <i class="iconfont iconplus-circle" />
                  创建/导入简历
                </div>
              </el-option>
            </el-select>
          </div>
          <div class="resume-select-switch" @click="switchOrder()" v-if="!defaultCvFirst">
            <el-tooltip class="item" effect="dark" content="调整顺序" placement="top">
              <i class="iconfont icontiaozhengshunxu" />
            </el-tooltip>
          </div>
        </div>
        <div class="resume-select" v-if="!defaultCvFirst">
          <div class="resume-select-title">
            {{this.cv_lang === "cn" ? "中文简历" : "英文简历"}}
          </div>
          <div class="resume-select-value">
            <img class="icon" src="https://files.wondercv.com/service_cv.png">
            <div class="text">
              {{cv_name}}
            </div>
          </div>
        </div>
        <div :class="otherCvToken ? 'download-btn' : 'download-btn download-btn-disabled'"
             @click="download"
        >
          <i class="iconfont iconbaocunbendi1"/>
          下载PDF
        </div>
      </div>
    </div>
  </w-dialog>
</template>

<script>
  import WDialog from '../../../../components/base/dialog'
  import api from '@/api'
  import {routerTo, get_tUser} from '@/assets/js/util';
  import {mapState} from "vuex";


  export default {
    name: 'campus-code',
    props: {
      dialogState: {
        type: Boolean,
        default: false
      },
      token: {
        type: String,
        default: ''
      },
      cv_name: {
        type: String,
        default: ''
      },
      cv_lang: {
        type: String,
        default: "cn"
      },
      handleDownload: {
        type: Function
      }
    },
    data () {
      return {
        defaultCvFirst: true,
        otherCvs: [],
        otherCvToken: ""
      }
    },
    mounted () {
    },
    computed: {
      ...mapState('cv', ['cvs'])
    },
    watch: {},
    components: {
      WDialog
    },
    async created(){
      await this.$store.dispatch('cv/getCvsList');
      this.otherCvs = this.cvs.filter(x => x.lang !== this.cv_lang)
      // console.log(this.otherCvs)
      // console.log(this.qrUrl,this.token,this.$route.params.token,api.cvsV2.cvsJobsRecommend())
    },
    methods: {
      // 关闭弹窗
      handleClose () {
        this.$emit('handleClose')
      },
      // 更改中英文顺序
      switchOrder () {
        this.defaultCvFirst = !this.defaultCvFirst
      },
      // 下载
      download() {
        if (this.otherCvToken) {
          // console.log(this.otherCvToken)
          // console.log("download")
          this.$emit("handleDownload",
                     {type: "combine",
                      cvTokens: (this.defaultCvFirst ?
                        [this.token, this.otherCvToken] :
                        [this.otherCvToken, this.token])})
          this.$emit("handleClose")
        }
      },
      // 创建新简历
      goToMoban() {
        routerTo(`/jianlimoban/`, '_blank')
        this.$emit("handleClose")
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/public";
  .combine-cv-container {
    box-sizing: border-box;
    padding: 32px;
    width: 446px;
    // height:467px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 8px 0px rgba(0,0,0,0.13);
    border-radius:4px;
    .main_header {
      margin: 0 auto;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 26px;
      //background-color: chartreuse;
      .header_title {
        width: 90px;
        height: 24px;
        font-size: 18px;
        font-weight: 500;
        color: #404040;
        line-height: 24px;
      }
      .close {
        font-size: 20px;
        color: #9C9C9C;
        cursor: pointer;
        .iconfont {
          font-size: 20px!important;
        }
      }
    }
    .main_body {
      .resume-select {
        display: flex;
        align-items: center;
        margin-bottom: 18px;
        &-title {
          // width: 56px;
          height: 14px;
          font-size: 12px;
          font-weight: 400;
          color: #404040;
          line-height: 14px;
        }
        &-value {
          // width: 290px;
          background: #F9F9F9;
          border-radius: 4px;
          margin-left: 14px;
          padding: 10px 16px;
          display: flex;
          align-items: center;
          border-top: 1px solid #F9F9F9;
          border-bottom: 1px solid #F9F9F9;
          .icon {
            height: 18px;
            margin-right: 8px;
          }
          .text {
            max-width: 233px;
            width: 233px;
            height: 18px;
            font-size: 14px;
            font-weight: 400;
            color: #404040;
            line-height: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        &-select {
          margin-left: 14px;
          width: 287px;
          .no-resume {
            .hint {
              height: 14px;
              font-size: 14px;
              font-weight: 400;
              color: #BCBCBC;
              line-height: 14px;
            }
            .click {
              height: 14px;
              font-size: 14px;
              font-weight: 400;
              color: #FF6644;
              line-height: 14px;
            }
          }
        }
        &-switch {
          width: 15px;
          height: 15px;
          margin-left: 14px;
          color: #AEB2BD;
          font-size: 15px;
          cursor: pointer;
          &:hover {
            color: #505667;
          }
        }
      }
      .download-btn {
        margin: 40px auto 0;
        width: 178px;
        height:36px;
        background:rgba(255,102,68,1);
        border-radius:4px;
        text-align: center;
        line-height: 36px;
        font-size:14px;
        font-weight:400;
        color:rgba(255,255,255,1);
        cursor: pointer;
        &:hover{
          background-color: #FF8569;
        }
      }
      .download-btn-disabled {
        cursor: not-allowed !important;
        background-color: #CFCFCF !important;
      }
      .iconbaocunbendi1 {
        margin-top: 1px;
      }
    }
  }
</style>
<style lang="scss">
  .combine-select-option {
    width: 286px;
    max-width: 286px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    .no-resume {
      color: #FF6644;
      &:hover {
        color: #FF8569;
      }
    }
  }
</style>
